var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Careers"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 4165,
    transform: "translate(-1151 -4103)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "footer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mdi:twitter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.973 4.00008C14.4597 4.23341 13.9064 4.38675 13.333 4.46008C13.9197 4.10675 14.373 3.54675 14.5864 2.87341C14.033 3.20675 13.4197 3.44008 12.773 3.57341C12.2464 3.00008 11.5064 2.66675 10.6664 2.66675C9.0997 2.66675 7.8197 3.94675 7.8197 5.52675C7.8197 5.75341 7.84637 5.97342 7.89303 6.18008C5.5197 6.06008 3.40637 4.92008 1.9997 3.19341C1.75303 3.61341 1.61303 4.10675 1.61303 4.62675C1.61303 5.62008 2.11303 6.50008 2.88637 7.00008C2.41303 7.00008 1.97303 6.86675 1.58637 6.66675V6.68675C1.58637 8.07341 2.57303 9.23341 3.8797 9.49341C3.46026 9.60871 3.01973 9.62468 2.59303 9.54008C2.7741 10.1084 3.12873 10.6057 3.60704 10.962C4.08536 11.3184 4.66333 11.5159 5.2597 11.5267C4.24881 12.3271 2.99571 12.7597 1.70637 12.7534C1.4797 12.7534 1.25303 12.7401 1.02637 12.7134C2.29303 13.5267 3.7997 14.0001 5.41303 14.0001C10.6664 14.0001 13.553 9.64008 13.553 5.86008C13.553 5.73341 13.553 5.61341 13.5464 5.48675C14.1064 5.08675 14.5864 4.58008 14.973 4.00008Z",
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0a03a910e96cf4b1e24dd2510bbaef0a.svg";
export { ForwardRef as ReactComponent };